import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/admin', // 默认使用 /admin
  timeout: 10000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    if (store.getters.token) {
      // 让每个请求携带令牌
      // ['Authorization'] 是自定义头部键，按照文档使用 Bearer 格式
      config.headers['Authorization'] = `Bearer ${getToken()}`
    }
    return config
  },
  error => {
    // 处理请求错误
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  /**
   * 如果您想要获取 http 信息，如头信息或状态
   * 请返回  response => response
  */

  /**
   * 通过自定义状态码确定请求状态
   * 这里只是一个例子，通用约定 200 或 20000 为成功
   */
  response => {
    const res = response.data

    // 如果自定义状态码不是 200，则将其视为错误
    if (res.code !== 200) {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })

      // 401: 未授权，请重新登录
      if (res.code === 401) {
        // 重新登录
        MessageBox.confirm('您已登出，您可以取消停留在此页面，或重新登录', '确认登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    // 检查HTTP状态码
    if (error.response && error.response.status === 401) {
      Message({
        message: '登录已过期，请重新登录',
        type: 'error',
        duration: 5 * 1000
      })
      
      // 直接重置token并跳转到登录页
      store.dispatch('user/resetToken').then(() => {
        // 跳转到登录页面
        window.location.href = '/login';
      });
      
      return Promise.reject(error)
    }
    
    // 提取后端返回的错误信息
    let errorMessage = error.message;
    if (error.response && error.response.data) {
      // 优先使用后端返回的message
      errorMessage = error.response.data.message || error.response.data.msg || errorMessage;
    }
    
    Message({
      message: errorMessage,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
